<template>
  <div class="advertiseUIWrapper">
    <div class="advertiseUIInnerContainer">
      <div class="boxImgDiv">
        <div class="pointBoxDiv">
          <img v-bind:src="pointBoxImg">
          <span>포인트</span>
        </div>
        <div class="couponBoxDiv">
          <img v-bind:src="couponBoxImg">
          <span>쿠폰</span>
        </div>
      </div>
      <div class="contentContainer">
        <div class="userInfoDiv">
          <div class="thumbnailsAndNameDiv">
            <img class="thumbnails" v-bind:src="thumbnails">
            <div class="nameAndCategoryDiv">
              <div class="nameAndFollowBtnDiv">
                <span class="userName">{{userName}}</span>
                <img class="followBtn" v-bind:src="followBtnImg">
              </div>
              <span class="category">{{category}}</span>
            </div>
          </div>
          <div class="couponAndOptionImgDiv">
            <img class="rewardImg" v-bind:src="rewardImg">
            <img class="optionImg" v-bind:src="optionImg">
          </div>
        </div>
        <div class="titleDiv">
          <img v-bind:src="titleImg">
          <div class="titleText" v-bind:style="style.titleTextDivStyle">{{titleText}}</div>
        </div>
        <div class="answerListDiv">
          <div class="answerDiv" v-for="count in answerCount" v-bind:key="count">
            <img v-bind:src="answerImg[count - 1]">
            <div class="answerText" v-bind:style="style.answerTextDivStyle[count - 1]">{{answerText[count - 1]}}</div>
          </div>
        </div>
        <div class="footerDiv">
          <div class="footerTextDiv">
            <span>참여 -명</span>
            <span>댓글 -개</span>
          </div>
          <div class="footerImgDiv">
            <img v-bind:src="footerNextImg">
            <img v-bind:src="footerArrowImg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  data () {
    return {
      pointBoxImg: require('@/assets/img/reward_point_icon.png'),
      couponBoxImg: require('@/assets/img/reward_coupon_icon.png'),
      followBtnImg: require('@/assets/img/advertise_ui_follow_btn.png'),
      rewardImg: require('@/assets/img/void_icon.png'),
      optionImg: require('@/assets/img/advertise_ui_option.png'),
      footerNextImg: require('@/assets/img/advertise_ui_footer_next.png'),
      footerArrowImg: require('@/assets/img/advertise_ui_footer_arrow.png'),
      userName: null,
      category: null,
      thumbnails: null,
      titleText: null,
      titleImg: null,
      answerText: null,
      answerImg: null,
      answerCount: null,
      tempImg: require('@/assets/img/reward_coupon_icon.png'),
      style: {
        titleTextDivStyle: '',
        answerTextDivStyle: [
          '',
          '',
          '',
          ''
        ]
      }
    }
  },
  methods: {
    setProps: function () {
      if(this.data.isRewardTypeCoupon) {
        this.rewardImg = require('@/assets/img/reward_coupon_icon.png')
      }else if(!this.data.isRewardTypeCoupon) {
        this.rewardImg = require('@/assets/img/reward_point_icon.png')
      }
      this.category = this.data.category != null ? this.data.category : '#-'
      this.titleText = this.data.titleText != null ? this.data.titleText : '-'
      this.titleImg = this.data.titleImg != null ? this.data.titleImg : require('@/assets/img/advertise_ui_no_title_img.png')
      let answerText = []
      let answerImg = []
      for(var i = 0; i < 4; i++) {
        answerText.push(this.data.answerText[i] != null ? this.data.answerText[i] : '-')
        answerImg.push(this.data.answerImg[i] != null ? this.data.answerImg[i] : require('@/assets/img/advertise_ui_no_answer_img_no_' + (i + 1) + '.png'))
      }
      this.answerText = answerText
      this.answerImg = answerImg
      this.answerCount = this.data.answerCount != null && this.data.answerCount !== 0 ? this.data.answerCount : 2
    },
    setTitleDivStyle: function () {
      this.style.titleTextDivStyle = 'left: 178px; '
      if(this.data.titleImg != null) {
        this.style.titleTextDivStyle += 'top: 436px;'
      }else {
        this.style.titleTextDivStyle += 'top: 384px;'
      }
    },
    setAnswerDivStyle: function () {
      // relative 기준은 rightSideWrapper
      this.style.answerTextDivStyle[0] = 'left: 115px; top: 535px;'
      this.style.answerTextDivStyle[1] = 'left: 241px; top: 535px;'
      this.style.answerTextDivStyle[2] = 'left: 115px; top: 635px;'
      this.style.answerTextDivStyle[3] = 'left: 241px; top: 635px;'
    }
  },
  created: function () {
    this.userName = this.$store.getters.getAdUserStateValue('name')
    this.thumbnails = this.$store.getters.getAdUserStateValue('thumbnail')
    this.setProps()
    this.setAnswerDivStyle()
    this.setTitleDivStyle()
  },
  watch: {
    data: function () {
      this.setProps()
      this.setTitleDivStyle()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.advertiseUIWrapper{
  padding: 12px;
  border: solid 1px #0099FF;
  border-radius: 1rem;
  background-color: white;
  width: 282px;
  height: 579px;
}

.advertiseUIInnerContainer{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px #0099FF;
  border-radius: 1rem;
  background-color: #F2F2F2;
  width: 100%;
  height: 100%;
}

.boxImgDiv{
  display : -webkit-flex;
  display : flex;
}

.boxImgDiv > .pointBoxDiv {
  display : -webkit-flex;
  display : flex;
  align-items: center;
  margin-top: 44px;
  margin-bottom: 24px;
  width: 93px;
  height: 42px;
  border: #06DDFF solid 2px;
  border-radius: 24px;
  background-color: white;
  margin-right: 15px;
}

.pointBoxDiv > img {
  margin: 0 5px 0 10px;
  width: 32px;
  height: 32px;
}

.pointBoxDiv > span {
  font-size: 11px;
  font-weight: bold;
}

.boxImgDiv > .couponBoxDiv {
  display : -webkit-flex;
  display : flex;
  align-items: center;
  margin-top: 44px;
  width: 81px;
  height: 42px;
  border: #06DDFF solid 2px;
  border-radius: 24px;
  background-color: white;
}

.couponBoxDiv > img {
  margin: 0 5px 0 10px;
  width: 32px;
  height: 32px;
}

.couponBoxDiv > span {
  font-size: 11px;
  font-weight: bold;
}

.contentContainer {
  width: 263px;
  height: 428px;
  background-color: white;
}

.userInfoDiv {
  display : -webkit-flex;
  display : flex;
  justify-content: space-between;
  background-color: white;
  width: 100%;
  height: 48px;
}

.thumbnailsAndNameDiv {
  display : -webkit-flex;
  display : flex;
  align-items: center;
  flex: 0.8;
}

.thumbnailsAndNameDiv > .nameAndCategoryDiv {
  display : -webkit-flex;
  display : flex;
  justify-content: center;
  flex-direction: column;
  flex: auto;
  height: 48px;
}

.nameAndCategoryDiv > .nameAndFollowBtnDiv {
  font-size: 10px;
  display : -webkit-flex;
  display : flex;
  align-items: flex-end;
}

.nameAndFollowBtnDiv > .followBtn{
  margin-left: 5px;
  width: 32px;
  height: 16px;
}

.nameAndCategoryDiv > .category {
  font-size: 10px;
  color: #0099FF;
}

.thumbnailsAndNameDiv > .thumbnails {
  width: 32px;
  height: 32px;
  margin: 0 8px;
  border-radius: 50%;
}

.couponAndOptionImgDiv {
  display : -webkit-flex;
  display : flex;
  align-items: center;
  justify-content: space-between;
  flex: 0.2;
}

.couponAndOptionImgDiv > .rewardImg {
  width: 32px;
  height: 32px;
}

.couponAndOptionImgDiv > .optionImg {
  width: 22px;
  height: 20px;
}

.titleDiv {
  background-color: white;
  width: 100%;
  height: 144px;
  margin-bottom: 2px;
}

.titleDiv > img{
  width: 100%;
  height: 100%;
}

.titleDiv > .titleText{
  position: absolute;
  text-align: center;
  padding: 3px 5px;
  background-color: black;
  color: white;
  font-size: 13px;
  font-weight: bold;
  min-width: 54px;
  max-width: 214px;
  transform: translate(-50%, -100%);
}

.answerListDiv {
  display : -webkit-flex;
  display : flex;
  flex-wrap : wrap;
  width: 100%;
  padding: 0 5px;
}

.answerDiv {
  background-color: white;
  width: 120px;
  height: 94px;
  margin: 2px;
  border: 1px solid #CFCFCF;
}

.answerDiv > img{
  width: 100%;
  height: 100%;
}

.answerDiv > .answerText{
  position: absolute;
  white-space: normal;
  text-align: center;
  padding: 3px;
  background-color: black;
  font-size: 11px;
  font-weight: bold;
  color: white;
  min-width: 24px;
  max-width: 110px;
  transform: translate(-50%, -100%);
}

.footerDiv{
  display : -webkit-flex;
  display : flex;
  background-color: white;
  width: 255px;
  font-size: 10px;
  padding: 0 4px;
}

.footerDiv > div {
  display : -webkit-flex;
  display : flex;
  justify-content: space-between;
  font-size: 10px;
  padding: 6px 3px;
  align-items: center;
  flex: 0.5;
}

.footerImgDiv > img {
  margin-top: 2px;
  width: 24px;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/advertiseUI.vue